
Array.prototype.$method('find', function (fn, self) {
  var target = null

  var ary = this
  if (!(this instanceof Array)) {
    ary = Array.from(this)
  }

  ary.some(function (elm, i) {
    if (fn.call(self, elm, i, this)) {
      target = elm
      return true
    }
  })

  return target
})
